const topics = [
  { label: '热血战斗', hot: '12.5万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '异世界转生', hot: '9.8万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: '修仙玄幻', hot: '8.3万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { label: '恋爱日常', hot: '7.6万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '悬疑推理', hot: '6.2万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: '搞笑喜剧', hot: '5.9万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { label: '3D国漫', hot: '10.1万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '韩漫彩色', hot: '4.8万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: '剧场版', hot: '3.5万讨论', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-600">动漫爱好者们正在热烈讨论的话题，加入聊天吧</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topics.map((item) => (
            <div
              key={item.label}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-full ${item.color} text-sm font-medium cursor-pointer transition-all hover:scale-105 whitespace-nowrap`}
            >
              <span>{item.label}</span>
              <span className="text-[10px] opacity-70">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}